import { useEffect, useState } from 'react';
import { Modal, message, Form, Button, Checkbox, Radio, InputNumber } from 'antd';
import API from '../../../../services/API';
import LoaderComponent from '../../../Loader';

export default function SubscriptionRenewModal({
  userId,
  refreshList,
}) {
  const labelCol = {span: 12};

  const [subscriptionPlans, setSubscriptionPlans] = useState(null);
  const [subscriptionPlanId, setSubscriptionPlanId] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [trialDays, setTrialDays] = useState(30);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalLoading, showModalLoading] = useState(false);

  useEffect(() => {
    const fetchSubscriptionPlans = async () => {
      try {
        showModalLoading(true);
        const response = await API.getSubscriptionPlans();
        setSubscriptionPlans(response.subscriptionPlans);
      } catch (error) {
        message.error('Failed to fetch subscription plans.');
      } finally {
        showModalLoading(false);
      }
    };

    fetchSubscriptionPlans();
  }, []);

  const showModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  }

  const onFinishFailed = (error) => {
    console.log('new error', { ... error});
  };

  const addTrialSubscription = async (data) => {
    console.log('addTrialSubscription', data);
    
    showModalLoading(true);
    const {
      subscriptionPlanId,
      trialDays,
    } = data;

    const requestData = {
      userId,
      subscriptionId: subscriptionPlanId,
      trialDays
    };

    const request = API.postAddTrialSubscription(requestData);

    request.then((resp) => {
      showModalLoading(false);
      setModalVisible(false);
      alert(resp?.message || 'Successfully deleted')
      if (refreshList) refreshList();
    }).catch((error) => {
      alert(error?.message || 'Something went wrong')
      showModalLoading(false);
    });
  }

  const onPlanChange = (e) => {
    setSelectedPlan(e.target.value);
  }


  return (
    <>
      <Button type="danger" onClick={showModal} style={{ marginLeft: "auto" }}>
        Create New Subscription
      </Button>
      <Modal
        title={'Create New Subscription'}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        closable={true}
        open={modalVisible}
        footer={null}
        className="confirm-modal"
      >
        <>
          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            style={{
              maxWidth: 600,
            }}
            initialValues={{
              subscriptionPlanId,
              trialDays,
            }}
            onFinish={addTrialSubscription}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div>
              <Form.Item
                label="Subscription Plan"
                labelCol={labelCol}
                name="subscriptionPlanId"
                rules={[
                  {
                    required: true,
                    message: 'Please select a plan',
                  },
                ]}
                extra={selectedPlan && subscriptionPlans && subscriptionPlans.find((plan) => plan.id === selectedPlan)?.billedText}
              >
                <Radio.Group onChange={onPlanChange}>
                  { subscriptionPlans && subscriptionPlans.map((plan) => <Radio.Button key={plan.id} value={plan.id} title={plan.billedText}>{plan.title}</Radio.Button> )}
                </Radio.Group>
              </Form.Item>
            </div>
            <div>
              <Form.Item
                label="Trial Days"
                labelCol={labelCol}
                name="trialDays"
                extra={<small>Customer will be charged the amount (mentioned above) after the trial days are over.</small>}
              >
                <InputNumber min={1} max={31} />
              </Form.Item>
            </div>
            <div>
                <Form.Item >
                <Button type="primary" htmlType="submit" disabled={modalLoading}>
                  Create New Subscription
                </Button>
                &nbsp;
                <Button htmlType="button" onClick={closeModal} disabled={modalLoading}>
                  Close
                </Button>
                </Form.Item>
            </div>
          </Form>
          {modalLoading && <LoaderComponent />}
        </>
      </Modal>
    </>);

}